module.exports = __webpack_public_path__ + "allied_yacht_vertical_png_120.7e09d77.png";